import classNames from 'classnames'
import React from 'react'
import cn from '../../../classnames.scss'
import {TitleProps} from './interfaces'
import s from './title.scss'

export const Title: React.FC<TitleProps> = ({text, dataHook = '', className}) => (
  <h1 className={classNames(s.title, cn.evTitleFont, cn.formTitleColor, className)} data-hook={dataHook}>
    {text}
  </h1>
)
